import classNames from "classnames";
import React from "react";
import { Text } from "../../text";
import { SelectProps } from "../select";
import { CSS_CLASSES } from "../select-css-classes";
import { OptionsToString, SelectOption } from "../select.types";

export interface SelectOptionsListItemProps<S extends SelectOption> {
  option: S;
  highlighted?: boolean;
  optionToString: OptionsToString<S>;
  isGroupOption?: boolean;
  color?: SelectProps["color"];
}

export const SelectOptionsListItem = <S extends SelectOption = SelectOption>({
  option,
  highlighted = false,
  optionToString,
  isGroupOption = false,
  color = "interactive",
}: SelectOptionsListItemProps<S>) => (
  <div
    className={classNames(CSS_CLASSES.SELECT_OPTION_LIST_ITEM, {
      [CSS_CLASSES.SELECT_OPTION_LIST_ITEM_DEFAULT]: !highlighted,
      [CSS_CLASSES.SELECT_OPTION_LIST_ITEM_HIGHLIGHTED]: highlighted && color === "interactive",
      [CSS_CLASSES.SELECT_OPTION_LIST_ITEM_HIGHLIGHTED_PRIMARY]: highlighted && color === "primary",
      [CSS_CLASSES.SELECT_OPTION_LIST_ITEM_DISABLED]: option.disabled,
      [CSS_CLASSES.SELECT_OPTION_GROUP_LIST_ITEM]: isGroupOption,
    })}
  >
    <Text variant="body-long" color="currentcolor">
      {optionToString(option)}
    </Text>
  </div>
);
